// Elegant / minimalist design tokens (Swiss + Luxury, slate + indigo, light & dark)
export const PAGE = "min-h-screen bg-white dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors";

export const CARD =
  "bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-800 rounded-xl transition-all duration-300 hover:-translate-y-1 hover:border-indigo-300 dark:hover:border-indigo-500/40 hover:shadow-lg hover:shadow-slate-200/50 dark:hover:shadow-black/30";

export const PANEL =
  "bg-white dark:bg-slate-900/70 border border-slate-200 dark:border-slate-800 rounded-xl";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 bg-indigo-600 hover:bg-indigo-500 text-white font-medium text-sm px-5 py-2.5 rounded-lg transition-all duration-300 shadow-sm shadow-indigo-600/20 disabled:opacity-50 disabled:cursor-not-allowed";

export const BTN_GHOST =
  "inline-flex items-center justify-center gap-2 border border-slate-200 dark:border-slate-800 hover:border-slate-300 dark:hover:border-slate-700 hover:bg-slate-50 dark:hover:bg-slate-800/60 text-slate-700 dark:text-slate-200 font-medium text-sm px-5 py-2.5 rounded-lg transition-all duration-300";

export const INPUT =
  "w-full bg-slate-50 dark:bg-slate-900/60 border border-slate-200 dark:border-slate-800 rounded-lg px-4 py-2.5 text-sm text-slate-900 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition";

export const ICON_BTN =
  "inline-flex items-center justify-center gap-2 border border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-800/70 text-slate-700 dark:text-slate-200 rounded-lg p-2 transition-colors";

export const BADGE =
  "inline-flex items-center gap-1.5 text-[10px] tracking-wider uppercase font-mono2 px-2 py-1 rounded-md border";
